jQuery($ => {
  class Spotlight {
    constructor(element){
      this._        = element;
      this._element = $(element);
      this._mouseX  = 0;
      this._mouseY  = 0;
      this._xp      = 0;
      this._yp      = 0;
      this._top     = '';
      this._left    = '';
      this._right   = '';
      this._bottom  = '';

      this._spotlight       = this._element.find('.o-homepage-hero__spotlight');
      this._spotlightTop    = '';
      this._spotlightRight  = '';
      this._spotlightBottom = '';
      this._spotlightLeft   = '';

      this.init()
    }

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    setupHandlers(){
      this._element.on('resize mouseenter mousemove', event => {
        this.handleFollowMouse(event);
        this.handleTouchedEdges(event);

      });
      
      this._element.on('mouseleave', () => {
        this.handleTouchedEdges()
      });
      
    }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ handleFollowMouse
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleFollowMouse(event) {
      this._mouseX = event.pageX - (this._spotlight.innerWidth()/2);
      this._mouseY = event.pageY - (this._spotlight.innerHeight()/2);
      this._xp += ((this._mouseX - this._xp)/6);
      this._yp += ((this._mouseY - this._yp)/6);

      this._spotlight.css({
        left: this._xp + 'px',
        top: this._yp + 'px',
        margin: 0
      });
    }

//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
// ✅ handleTouchedEdges
//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTouchedEdges() {
      this._top            = this._element.offset().top;
      this._left           = this._element.offset().left;
      this._right          = this._element.offset().left + this._element.innerWidth();
      this._bottom         = this._element.offset().top + this._element.innerHeight();
      this.spotlightLeft   = this._spotlight.offset().left;
      this.spotlightRight  = this._spotlight.offset().left + this._spotlight.innerWidth();
      this.spotlightTop    = this._spotlight.offset().top;
      this.spotlightBottom = this._spotlight.offset().top + this._spotlight.innerHeight();

      if(this.spotlightLeft <= 0 || this.spotlightRight > this._right || this.spotlightTop <= 0 || this.spotlightBottom > this._bottom){
        this.handleResetSpotlight();
      }
  }

//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
// ✅ handleResetSpotlight
//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleResetSpotlight() {
      this._spotlight.attr('style', '');
    }
  }

//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
// ✅ Setup jQuery Plugin
//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    $.fn.component = function() {
      var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;

      for(i = 0; i < l; i++){
        if (typeof opt === 'object' || typeof opt === 'undefined')
          _[i].component = new Spotlight(_[i], opt);
        else
          ret = _[i].component[opt].apply(_[i].component, args);
        if(typeof ret !== 'undefined') return ret;
      }

      return _;
    }

  
  // $('.o-homepage-hero').component();

  

});